export default "__VITE_ASSET__DGI5kitI__"